// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1sM-Y","legacyBtn":"MutateMid_legacyBtn__1--36"};